import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

export const ImageWrapper = styled.div`
  background-image: url('${({ url }) => url}');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 250px;
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;

  ${breakpoint('tablet')`
    height: 400px
  `}
`;

export const CategoryWrapper = styled.div`
  background: #f1f2f3;
  padding: 20px 0;
  margin-bottom: 30px;
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;

  ${breakpoint('tablet')`
    margin-bottom: 70px;
  `}
`;

export const Container = styled.div`
  width: 100%;
  padding: 0 20px;
  margin: 0 auto;

  ${breakpoint('tablet')`
    width: 90%;
    padding: 0;
  `}

  ${breakpoint('desktop')`
    width: 1100px;
  `}
`;

export const StyledList = styled.ul`
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  list-style: none;
  margin: 0;
`;

export const ListItem = styled.li`
  display: inline-block;
  font-size: 16px;
  font-weight: ${({ active }) => (active ? '500' : '400')};
  text-transform: uppercase;
  padding: 20px 30px;
  margin: 0;

  color: '#1e1e1e';

  a:active,
  a:link,
  a:visited {
    ${({ active }) => active && 'border-bottom: 1px solid #ccc;'}
  }
`;
export const Link = styled.a`
  text-align: center;
  color: '#1e1e1e';

  &:active,
  &:link,
  &:visited {
    text-align: center;
    color: '#1e1e1e';
  }
`;

export const SelectWrapper = styled.div`
  position: relative;
`;

export const Select = styled.div`
  width: 100%;
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  padding: 15px 30px 15px 20px;
  position: relative;
  text-transform: uppercase;
  background: ${({ open }) => (open ? '#fff' : 'transparent')};
  border: 2px solid ${({ open }) => (open ? '#1e1e1e' : '#ccc')};
  border-bottom-color: ${({ open }) => (open ? 'transparent' : '#ccc')};
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    right: 15px;
    top: 50%;
    height: 10px;
    width: 10px;
    transform: translateY(-50%) rotate(${({ open }) => (open ? '135deg' : '-45deg')});
    border-bottom: 2px solid #1e1e1e;
    border-left: 2px solid #1e1e1e;
    transition: transform 0.2s ease;
  }
`;

export const SelectDropDown = styled.div`
  display: ${({ open }) => (open ? 'block' : 'none')};
  position: absolute;
  background: #fff;
  width: 100%;
  border: 2px solid #1e1e1e;
  border-top: transparent;
  margin-top: -2px;
  z-index: 1;
`;

export const DropDownItem = styled.div`
  &:first-child {
    margin-top: 10px;
  }

  &:last-child {
    margin-bottom: 10px;
  }

  &:hover {
    background: #ccc;
  }
`;

export const DropDownLink = styled.a`
  display: block;
  width: 100%;
  height: auto;
  padding: 10px 10px 10px 20px;

  &,
  &:link,
  &:visited,
  &:active {
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    color: #1e1e1e;
  }
`;
